import { ClipPathLinks } from "./ui/ClipPathLinks";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Trabajos", href: "#trabajos" },
  { label: "Contacto", href: "#contacto" },
];

function Footer() {
  return (
    <footer className="bg-primary text-white">
      {/* Social links grid */}
      <div className="max-w-2xl mx-auto px-6 pt-16 pb-8">
        <p className="text-center text-sm uppercase tracking-[0.2em] text-gray-400 mb-6">
          Seguinos
        </p>
        <ClipPathLinks />
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a
            href="/"
            className="text-sm font-bold tracking-[0.2em] hover:text-gray-300 transition-colors"
          >
            STUDIO FORM
          </a>

          {/* Nav links */}
          <ul className="flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Copyright */}
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Studio Form. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
